// help-center-view.js

import $                    from 'jquery';
import { View } from 'backbone';
import ModalView            from 'common-views/ModalView';
import contentTemplate      from 'help-center-view.ejs';
import listService          from 'ListService';
import util                 from 'util/Util';
import constants            from 'Constants';
import eventBus from "../service/EventBus";

class HelpCenterView extends View {

    initialize( opts ) {
        let $div = $('<div />').appendTo('body');
        $div.attr('id', 'hold-dialog');
        
        this.options = opts || {};
        this.template = contentTemplate;

        this.$el = $("#hold-dialog");

        this.HelpCenterEnabled = util.isTrue(listService.userProfile.HelpCenterEnabled);
        
        this.model.set('helpUrl', constants.HELP_URL);
        this.model.set('quickStartUrl', constants.QUICK_START_URL);
        this.model.set('trainingVideosUrl', constants.TRAINING_VIDEOS_URL);
        this.model.set('fromMobile', opts.model.get('fromMobileOption'));
    }

    bindEvents(){
        let self = this;
        $('.close-help-center').on("click", (e) => {

            $(constants.DIALOG_ID).dialog("destroy");
            self.remove();
        });

        $('.form-designer-video').on("click", (e) => {
            $('#helpContent').hide();
            $('#helpVideo').show();
            e.preventDefault();
            e.stopPropagation();

            $("#dialog-help-center").dialog({ width: 645 });

            setTimeout(function(){
                self.playVideo();
            },1);
        });

        $('#quick-start-guide').on("click", (e) => {
            $('#quick-start-guide-link')[0].click();
        });

        $('#help-guide').on("click", (e) => {
            $('#help-guide-link')[0].click();
        });

        $('#training-videos').on("click", (e) => {
            $('#training-videos-link')[0].click();
        });

        $('#help-center-enabled').on("change", (e) => {
            e.stopPropagation();

            const propVal = e.currentTarget.checked;
            this.HelpCenterEnabled = propVal;

            if (self.model.get('fromMobile') !== undefined) {
                listService.userSettings.set('_moShAS', propVal.toString());
            }
            else {
                util.setShowEditorHelpCenter(propVal);
            }
        });

        $(".close-help-center").on("click", e => {
            e.preventDefault();
            e.stopPropagation();

            let dialog = $( '#dialog-help-center' );

            dialog.dialog( "close" );
            dialog.remove();

            $("#hold-dialog").remove();
        });

        $(".sub_topic_help").on("click", e => {
            $('#video-player').get(0).pause();
        });
    }

    render() {
        let mainKind = this.model.get('mainKind');
        let helpCenterTitle = '';
        let helpCenterVideoTitle = '';
        let helpCenterVideoContent = 'Provides a quick introduction to the major areas and functionality of the --mainKind--.';
        let helpCenterMainKind = '';
        let videoUrl = '';
        let idVideo = '';
        let _self = this;

        if (this.model.get('fromMobile')) {
            helpCenterTitle = 'Mobile Wizard';
            helpCenterVideoTitle = "--mainKind-- Video";
            helpCenterMainKind = 'Mobile Wizard';
            idVideo = constants.HELP_CENTER_WIZARD_VID;
            listService.userSettings.set('_moShAS', 'true');
        }
        else {
            util.setShowEditorHelpCenter('true');
            switch (mainKind) {
                case constants.KIND_DASHBOARD:
                    helpCenterTitle = "Dashboard";
                    helpCenterVideoTitle = "--mainKind-- Video";
                    helpCenterMainKind = 'Dashboard';
                    idVideo = constants.HELP_CENTER_DASHBOARD_VID;
                    break;
                case constants.KIND_LAYOUT:
                    helpCenterTitle = 'App Designer';
                    helpCenterVideoTitle = "--mainKind-- Video";
                    helpCenterMainKind = 'App Designer';
                    idVideo = constants.HELP_CENTER_FORMS_VID;
                    break;
                case constants.KIND_REPORT:
                    helpCenterTitle = 'Report Designer';
                    helpCenterVideoTitle = "--mainKind-- Video";
                    helpCenterMainKind = 'Report Designer';
                    idVideo = constants.HELP_CENTER_REPORTS_VID;
                    break;
            }
        }

        this.model.set('helpCenterTitle', helpCenterTitle + " Quick Tour");
        this.model.set('helpCenterVideoTitle', helpCenterVideoTitle.replace('--mainKind--', helpCenterMainKind));
        this.model.set('helpCenterVideoContent', helpCenterVideoContent.replace('--mainKind--', helpCenterMainKind));
   

         util.getURLFromPHPAsync(constants.HELP_VIDEOS + '?id=' + idVideo)
        .then(videoUrl => {
            
            this.model.set('videoUrl', videoUrl);

            if (_self.model.get('fromMobile') !== undefined) {
                this.model.set('canVideoBeSeen', false, { silent: true });
                if (!util.isTrue(listService.userSettings.get('_moShHC'))) {
                    this.model.set('canVideoBeSeen', true, { silent: true });
                }
            }

            this.$el.empty();
            this.$el.append(this.template(this.model.toJSON()));

            // Show modal popup window
            $('#dialog-help-center').dialog({
                autoOpen: true,
                height: "auto",
                width: 630,
                modal: true,
                resizable: false,
                buttons: [],
                dialogClass: 'helpCenterDialog',
                close: function (event, ui) {
                    event.stopPropagation();
                    let dialog = $('#dialog-help-center');
                    dialog.dialog("close");
                    dialog.remove();
                    $("#hold-dialog").remove();
                    _self.mobileDesignerWillOpen();
                }
            });

            $(this.$el).parent().find(".ui-dialog-titlebar").hide();
            $('#help-center-enabled').attr('checked', this.HelpCenterEnabled);

            this.bindEvents();

            //For new users
            if (this.model.get('canVideoBeSeen')) {
                $("#dialog-help-center").dialog({ width: 645 });
                this.playVideo();
            }
        })
        .catch(error => {
            console.error("Failed to load help center video:", error);
        });

    return this;
}

   
     
    playVideo() {
        $('#video-player').get(0).play();       
    }

    mobileDesignerWillOpen() {
        if (this.model.get('fromMobile') !== undefined) {
            if (this.model.get('canVideoBeSeen')) {
                listService.userSettings.set('_moShHC', "true");
            }

            // listService.mobileVideoHasBeenSeen = true;
            // PF-5694 Changed to store the value in user settings
            listService.userSettings.set('_moHCVideo', "true");
            if(!this.model.get('isForcedOpen')){
                eventBus.trigger(constants.OPEN_AFTER_VIDEO_PLAYED);
            }
        }
    }
}

export default HelpCenterView;
